module.exports = __webpack_public_path__ + "img/accessory_shirt_06.b22524e2.svg";